<template>
  <div class="columns is-centered">
    <section class="section">
      <div class="box">
        <div class="tabs is-toggle is-fullwidth" id="tabs">
          <ul>
            <li :class="[ activeTab === 'usingMileLogix' ? 'is-active' : '']">
              <a @click="activeTab='usingMileLogix'">
                <span>Using MileLogix</span>
              </a>
            </li>
            <li :class="[ activeTab === 'faq' ? 'is-active' : '']">
              <a @click="activeTab='faq'">
                <span>FAQ</span>
              </a>
            </li>
            <li :class="[ activeTab === 'contactSupport' ? 'is-active' : '']">
              <a @click="activeTab='contactSupport'">
                <span>Contact Support</span>
              </a>
            </li>
          </ul>
        </div>

        <div id="tab-content">
          <div class="content is-medium" v-if="activeTab==='usingMileLogix'">
            <figure class="image">
              <img src="@/assets/milelogix_howto.png">
            </figure>
          </div>

          <div class="content" v-if="activeTab==='faq'">
            <div class="columns">
              <div class="column">
                <p>
                  <strong>Q:</strong> How do I export a calendar ICS file?
                </p>
              </div>
              <div class="is-divider-vertical"></div>
              <div class="column">
                <p>
                  <strong>A:</strong> Links to calendar exports from popular calendering solutions.
                </p>
                <p>
                  <a
                    href="https://support.google.com/calendar/answer/37111?hl=en"
                    target="_blank"
                  >Google Calendar</a>,
                  <a
                    href="https://support.office.com/en-us/article/export-an-outlook-calendar-to-google-calendar-662fa3bb-0794-4b18-add8-9968b665f4e6"
                    target="_blank"
                  >Microsoft Outlook</a>,
                  <a
                    href="https://support.apple.com/guide/calendar/import-or-export-calendars-icl1023/mac"
                    target="_blank"
                  >Apple iCloud Calendar</a>
                </p>
              </div>
            </div>
            <br>
            <div class="columns">
              <div class="column">
                <p class="content">
                  <strong>Q:</strong> Why can't I see previously generated reports?
                </p>
              </div>
              <div class="is-divider-vertical"></div>
              <div class="column">
                <p>
                  <strong>A:</strong>
                  This feature is coming soon. Please contact support for more details.
                </p>
              </div>
            </div>
            <br>

            <div class="columns">
              <div class="column">
                <p class="content">
                  <strong>Q:</strong> My report failed to get generated!
                </p>
              </div>
              <div class="is-divider-vertical"></div>
              <div class="column">
                <p>
                  <strong>A:</strong>
                  Please retry generating a report or contact support.
                </p>
              </div>
            </div>

            <br>

            <div class="columns">
              <div class="column">
                <p class="content">
                  <strong>Q:</strong> My report was generated but it's empty!
                </p>
              </div>
              <div class="is-divider-vertical"></div>
              <div class="column">
                <p>
                  <strong>A:</strong>
                  A calendar must contain at least two events in a given day with addresses in the location field for a report to be generated.
                </p>
              </div>
            </div>
            <br>

            <div class="columns">
              <div class="column">
                <p class="content">
                  <strong>Q:</strong> How can I generate multiple reports in a single run?
                </p>
              </div>
              <div class="is-divider-vertical"></div>
              <div class="column">
                <p>
                  <strong>A:</strong>
                  Contact support for batch processing reports.
                </p>
              </div>
            </div>
            <br>

            <div class="columns">
              <div class="column">
                <p class="content">
                  <strong>Q:</strong> The mileage and drive time don't match Google Maps!
                </p>
              </div>
              <div class="is-divider-vertical"></div>
              <div class="column">
                <p>
                  <strong>A:</strong>
                  Mileage and drive time are calculated and optimized for shortest travel distance.
                </p>
              </div>
            </div>
          </div>

          <p class="content" v-if="activeTab==='contactSupport'">
            <a href="mailto:support@abalogix.com?subject=MileLogix Support">support@abalogix.com</a>
          </p>
          <!-- <form
            class="contactSupport"
            v-if="activeTab==='contactSupport'"
            @submit.prevent="contactSupport"
          >
            <div class="field">
              <div class="field-label">
                <label class="label">Please describe the issue you are having</label>
              </div>
              <div class="field">
                <div class="control">
                  <textarea class="textarea is-small has-fixed-size" placeholder></textarea>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <button class="button is-block is-fullwidth is-link">Submit</button>
              </div>
            </div>
          </form>-->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import "bulma-divider/dist/css/bulma-divider.min.css";
export default {
  name: "Documentation",
  data() {
    return {
      activeTab: "usingMileLogix"
    };
  }
};
</script>
